import request from '@/utils/request';

const PATH = '/banner';

export const getBannerList = () => request({
  url: PATH,
  method: 'get',
});
